import { render, staticRenderFns } from "./ToTheStars.vue?vue&type=template&id=4ffa1dd1&"
import script from "./ToTheStars.vue?vue&type=script&lang=ts&"
export * from "./ToTheStars.vue?vue&type=script&lang=ts&"
import style0 from "./ToTheStars.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports